(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('round', {
            parent: 'entity',
            url: '/round',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.round.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/round/rounds.html',
                    controller: 'RoundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('round');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('round-detail', {
            parent: 'entity',
            url: '/round/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.round.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/round/round-detail.html',
                    controller: 'RoundDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('round');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Round', function($stateParams, Round) {
                    return Round.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('round.new', {
            parent: 'round',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-dialog.html',
                    controller: 'RoundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                roundCode: null,
                                blacklisted: null,
                                created: null,
                                lastHist: null,
                                lastFore: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('round');
                });
            }]
        })
        .state('round.edit', {
            parent: 'round',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-dialog.html',
                    controller: 'RoundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Round', function(Round) {
                            return Round.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('round.delete', {
            parent: 'round',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/round/round-delete-dialog.html',
                    controller: 'RoundDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Round', function(Round) {
                            return Round.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('round', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
